(() => {
 const instances = new Map();
 function mount(root = document) {
  const nodes = [...root.querySelectorAll('[data-closing-film]')];
  if (root.matches?.('[data-closing-film]')) nodes.unshift(root);
  for (const section of nodes) {
   if (instances.has(section)) continue;
   const video=section.querySelector('video'), button=section.querySelector('button'), canvas=section.querySelector('canvas');
   if (!video || !button || !canvas) continue;
   const context=canvas.getContext('2d',{alpha:false}), abort=new AbortController(), signal=abort.signal;
   const mobile=matchMedia('(max-width:749px) and (max-aspect-ratio:3/5)'), reduced=matchMedia('(prefers-reduced-motion:reduce)');
   let near=false, visible=false, selected='', dead=false, manualPause=false, motionOptIn=false, frame=null, failed=false;
   const nativeFrames=typeof video.requestVideoFrameCallback==='function';
   video.defaultMuted=video.muted=true; video.loop=true; video.playsInline=true;
   section.dataset.playing='false';
   const stopPaint=()=>{if(frame!==null){if(nativeFrames)video.cancelVideoFrameCallback(frame);else cancelAnimationFrame(frame);frame=null;}};
   const mayPlay=()=>!dead&&visible&&!document.hidden&&!manualPause&&(!reduced.matches||motionOptIn)&&!failed;
   const poster=section.querySelector('.es-closing-film__poster');
   const posterImage=poster?.querySelector('img');
   const paintSource=(media)=>{
    if(!context||!media)return;
    const mw=media.videoWidth||media.naturalWidth,mh=media.videoHeight||media.naturalHeight;
    if(!mw||!mh)return;
    const portrait=mobile.matches&&!!video.dataset.mobile;
    section.dataset.variant=portrait?'mobile':'desktop';
    const stage=section.getBoundingClientRect();
    try{
     if(portrait){
      const scale=Math.min(1,640/Math.max(stage.width,stage.height)),width=Math.round(stage.width*scale),height=Math.round(stage.height*scale);
      if(canvas.width!==width||canvas.height!==height){canvas.width=width;canvas.height=height;}
      const fit=Math.min(width/mw,height/mh),w=mw*fit,h=mh*fit,x=(width-w)/2,y=(height-h)/2;
      context.drawImage(media,0,0,mw,mh,x,y,w,h);
      if(x>0){context.drawImage(media,0,0,1,mh,0,y,x+1,h);context.drawImage(media,mw-1,0,1,mh,x+w-1,y,width-x-w+1,h);}
      if(y>0){context.drawImage(media,0,0,mw,1,x,0,w,y+1);context.drawImage(media,0,mh-1,mw,1,x,y+h-1,w,height-y-h+1);}
     }else{
      const scale=Math.min(1,640/Math.max(mw,mh)),width=Math.round(mw*scale),height=Math.round(mh*scale);
      if(canvas.width!==width||canvas.height!==height){canvas.width=width;canvas.height=height;}
      context.drawImage(media,0,0,width,height);
     }
     section.dataset.backgroundReady='true';
     if(media===video)canvas.dataset.mediaTime=String(video.currentTime);
    }catch{}
   };
   const paint=()=>paintSource(section.dataset.ready==='true'&&video.readyState>=2?video:posterImage);
   const tick=()=>{frame=null;if(!mayPlay()||video.paused)return;paint();schedule();};
   const schedule=()=>{if(frame===null&&mayPlay()&&!video.paused)frame=nativeFrames?video.requestVideoFrameCallback(tick):requestAnimationFrame(tick);};
   const updateButton=()=>{section.dataset.playing=String(!video.paused);button.setAttribute('aria-label',video.paused?'Play film':'Pause film');};
   const pause=()=>{video.pause();stopPaint();updateButton();};
   const select=()=>{
    const portrait=mobile.matches&&!!video.dataset.mobile;
    const src=portrait?video.dataset.mobile:video.dataset.desktop;
    video.poster=portrait?video.dataset.posterMobile:video.dataset.posterDesktop;
    section.dataset.variant=portrait?'mobile':'desktop';
    if(!src)return false;
    if(selected!==src){pause();selected=src;failed=false;delete section.dataset.error;delete section.dataset.ready;button.hidden=false;video.src=src;video.load();}
    return true;
   };
   const sync=()=>{
    if(dead)return;
    const allowedMotion=!reduced.matches||motionOptIn;
    if(near&&allowedMotion)select();
    if(!mayPlay()||!selected){pause();return;}
    video.muted=true;
    video.play().then(()=>{if(!mayPlay()){pause();return;}section.dataset.ready='true';paint();schedule();updateButton();}).catch(()=>{updateButton();});
   };
   const onPlaying=()=>{if(!mayPlay()){pause();return;}section.dataset.ready='true';paint();schedule();updateButton();};
   const nearObserver=new IntersectionObserver(entries=>{near=entries.some(e=>e.isIntersecting);sync();},{rootMargin:'400px 0px'});
   const visibleObserver=new IntersectionObserver(entries=>{visible=entries.some(e=>e.isIntersecting&&e.intersectionRatio>=.12);section.dataset.visible=String(visible);sync();},{threshold:[0,.12]});
   nearObserver.observe(section);visibleObserver.observe(section);
   posterImage?.addEventListener('load',()=>{if(section.dataset.ready!=='true')paintSource(posterImage);},{signal});
   window.addEventListener('resize',paint,{signal});
   paint();
   button.hidden=false;
   button.addEventListener('click',()=>{
    if(!video.paused){manualPause=true;pause();}
    else{manualPause=false;motionOptIn=true;near=true;if(failed){failed=false;selected='';}sync();}
   },{signal});
   video.addEventListener('loadeddata',paint,{signal});
   video.addEventListener('playing',onPlaying,{signal});
   video.addEventListener('pause',()=>{stopPaint();updateButton();},{signal});
   video.addEventListener('seeked',()=>{paint();schedule();},{signal});
   video.addEventListener('error',()=>{failed=true;pause();delete section.dataset.ready;paintSource(posterImage);button.hidden=true;section.dataset.error='true';},{signal});
   document.addEventListener('visibilitychange',sync,{signal});window.addEventListener('pageshow',sync,{signal});
   mobile.addEventListener('change',()=>{if(near&&(!reduced.matches||motionOptIn))select();paint();sync();},{signal});
   reduced.addEventListener('change',()=>{motionOptIn=false;sync();},{signal});
   const cleanup=()=>{dead=true;pause();abort.abort();nearObserver.disconnect();visibleObserver.disconnect();video.removeAttribute('src');video.load();instances.delete(section);};
   instances.set(section,cleanup);
  }
 }
 mount();
 document.addEventListener('shopify:section:load',e=>mount(e.target));
 document.addEventListener('shopify:section:unload',e=>{for(const [s,cleanup]of instances)if(e.target.contains(s))cleanup();});
})();
